<template>
  <div class="modal fade" :id="''+id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !isEdit ? $t('access.doors.creation') : $t('access.doors.modification') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                      fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                      fill="currentColor"/>
                                </svg>
                            </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Input
                containerClass="col-12 mt-2 mb-5"
                :name="`${id}-name`"
                type="text"
                :label="$t('access.doors.name')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :placeholder="$t('access.doors.name')"
                :isRequired="true" size="lg"
                v-model="formData.name"
            />
            <Select2
                :parent-id="'#'+id"
                containerClass="col-12 mb-5"
                :name="'principal'+id"
                :multiple="false"
                :label="$t('access.doors.perimeter')"
                labelClass="mb-3"
                selectClass="form-select form-select-solid"
                :isRequired="true"
                :placeholderText="$t('access.doors.perimeter_placeholder')"
                v-model="formData.perimeter_id"
                :IsInputGroup="true"
                icon="bi bi-plus"
                :clickAddon="openPerimeterModal"
            >
              <option v-for="perimeter in getPerimeters" :key="perimeter.id" :value="perimeter.id">
                {{ perimeter.name }}
              </option>
            </Select2>
            <Input
                containerClass="col-12 mt-2 mb-5"
                :name="`${id}-number`"
                type="text"
                :label="$t('access.doors.material_number')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :placeholder="$t('access.doors.material_number')"
                :isRequired="false" size="lg"
                v-model="formData.device"
            />
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingDoors"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <CreatePerimeter @load="loadPerimeters" :id="'createPerimeterModal'+id" :parent="id"/>

</template>

<script setup>
import {ref, defineProps, computed, onMounted, watch} from 'vue'
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import CreatePerimeter from "@/Modules/Access/components/Modals/Perimeters/CreateOrUpdatePerimeter.vue";

const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    default: {
      id: '',
      name: '',
      perimeter_id: '',
      device: ''
    }
  },
  id: {
    type: String,
    required: true
  },
  parent: {
    type: String,
    required: false
  },
  isEdit: {
    type: Boolean,
    required: false
  }
})

const emits = defineEmits(['load'])

const formData = ref(props.form)
const isLoadingDoors = ref(false)

const getPerimeters = computed(() => store.getters['perimeters/getPerimeters'])

watch(() => props.form, (value) => {
  formData.value = props.form
}, { deep: true })

function openPerimeterModal(){
  $('#'+props.id).modal('toggle')
  $('#createPerimeterModal'+props.id).modal('toggle')
}

function submitData(){
  isLoadingDoors.value = true
  let action = props.isEdit ? 'doors/updateDoors' : 'doors/createDoors'
  let message = props.isEdit ? 'notification.doors_updated' : 'notification.doors_created'

  store.dispatch(action, formData.value)
      .then((response) => {
        emits('load')
        isLoadingDoors.value = false
        loadPerimeters()
        closeModal()
        formData.value = {
          id: '',
          name: '',
          perimeter_id: '',
          device: ''
        }
        window.toastr['success'](i18n.global.t(message))
      })
      .catch(err => {
        isLoadingDoors.value = false
      })
}

function closeModal(){
  if(props.parent){
    $('#'+props.parent).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
}

function loadPerimeters(perimeterId = null) {
  if(perimeterId) formData.value.perimeter_id = perimeterId
  store.dispatch("perimeters/loadPerimeters")
}

onMounted(() => {
  loadPerimeters()
})
</script>